export const ACCESS_CODE_ERRORS = ['Please enter a valid access code'];
